import { memo, useState, useEffect, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Overlay, Button, Text, Flex } from '@pancakeswap/uikit'
import { Notification } from '@/components'
import { Input as AntdInput } from 'antd'
import { ethers } from 'ethers'
import { AppContext } from '@/context'
import { privatekeyArray, privatekeyArrayChange } from '@/store'
import { createPortal } from 'react-dom'
import styled from 'styled-components'
import { ButtonSwapper } from '@/styles'
import { copyHandler } from '@/utils'
import { FormLabel } from '../../Header/style'

const Page = styled.div`
position: fixed;
left: 50%;
top: 50%;
transform: translate(-50%, -50%);
z-index: 101;
cursor: pointer;
word-break: break-all;
background-color:#fff;
padding: 10px;
width: 50%;
border-radius: 20px;

@media (max-width: 768px) {
  width: 90%;
}
`

function App({ btnCallback }) {
  const { Lang } = useContext(AppContext)
  const { TextArea } = AntdInput
  const dispatch = useDispatch()
  const keyArr = useSelector(privatekeyArray)
  const [privatekeyArr, setPrivatekeyArr] = useState(``)

  useEffect(() => {
    if (keyArr) {
      const keyArr_ = keyArr.join('\n')
      setPrivatekeyArr(keyArr_)
    }
  }, [keyArr])

  const privatekeyArrChange = (e) => {
    const str = e.target.value
    setPrivatekeyArr(str)
  }
  const click = () => {
    let _index = 0
    try {
      // 按行拆分
      let resultArr = privatekeyArr.split(/[(\r\n)\r\n]+/)

      // 去掉空行
      resultArr = resultArr.filter((item) => item.trim() !== '')

      // === 去重（保持顺序） ===
      const _config = Array.from(new Set(resultArr))

      if (_config.length === 0) return Notification.Error('私钥数量为0，请重新输入')

      // 检查每个私钥是否有效
      _config.forEach((key) => {
        const wallet = new ethers.Wallet(key)
        _index++
      })

      dispatch(privatekeyArrayChange(_config))
      btnCallback()

    } catch (error) {
      const number = _index === 0 ? 1 : _index + 1
      Notification.Error(`第${number}个私钥输入错误`)
    }
  }

  return createPortal(
    <>
      <Overlay />
      <Page>
        <Flex justifyContent='space-between' mb={10}>
          <FormLabel>{Lang.Importprivatekey}</FormLabel>
          <Flex style={{ gap: 10 }}>
            <FormLabel onClick={() => copyHandler(privatekeyArr)}>复制</FormLabel>
            <FormLabel onClick={btnCallback}>{Lang.close}</FormLabel>
            <FormLabel onClick={() => setPrivatekeyArr('')}>{'清空'}</FormLabel>
          </Flex>
        </Flex>

        <TextArea rows={10} value={privatekeyArr} onChange={privatekeyArrChange} placeholder={Lang.a7} />
        <ButtonSwapper>
          <Button mt='1rem' onClick={click}>{Lang.import}</Button>
        </ButtonSwapper>
      </Page>
    </>,
    document.body
  )
}

export default memo(App)